/**
 * DESCRIPTION: This is the Svelte store for all translatable system texts in the frontend
 */
import {writable} from "svelte/store";

export const translations = writable({});
